// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"191":"9dc299b7","2976":"2b18c203","4517":"2b18c203","7806":"e4fe395a","9768":"1868e4a8"}[chunkId] + ".chunk.css";
};